import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { PaleomapDisplay } from '~/components/outcrop/paleomap-display-v4';
import { useRouteParam } from '~/hooks/routing';

const PALAEOGEOGRAPHY_ROUTE = graphql(`
  query OutcropPalaeogeographyRoute($id: ID!) {
    outcropGet(id: $id) {
      ...outcropPaleogeographyParts
    }
  }
`);

export default function OutcropPalaeogeographyPage() {
  return (
    <ApolloProviderV4>
      <OutcropPalaeogeographyPageInner />
    </ApolloProviderV4>
  );
}

function OutcropPalaeogeographyPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(PALAEOGEOGRAPHY_ROUTE, {
    variables: { id: outcropId },
  });

  const outcrop = data?.outcropGet;

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return <PaleomapDisplay outcrop={outcrop} />;
}
